import styled from 'styled-components';

export const ContainerLoadScreen = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
